import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

import UsersSerialsContext from '../contexts/users-serials-context';
import AuthContext from '../contexts/auth-context';
import usePost from '../hooks/usePost';

import Error from './error';
import Loading from './loading';
import Header from './header';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
  },
}));

export default function LoginPage() {
  const classes = useStyles();

  const history = useHistory();

  const [loginForm, setLoginForm] = useState({ email: '', password: '' });

  const [response, login] = usePost({
    path: 'main',
    payload: { btn: 'login_web', ...loginForm },
  });

  const [res, logout] = usePost({
    path: 'main',
    payload: { btn: 'logout' },
  });

  function onSubmit(event: any) {
    event.preventDefault();
    setUser({ email: loginForm.email });
    login();
  }

  const { setUsersSerials } = useContext(UsersSerialsContext);
  const { setUser } = useContext(AuthContext);

  useEffect(() => {
    if (!!response.data) {
      setUsersSerials(response.data);
      history.push('/users-serials');
    }

    if (history.location.pathname === '/logout') {
      logout();
      history.push('/login');
    }

  }, [res, history, logout, setUser, setUsersSerials, response.data]);

  return (
    <Container className={classes.container} maxWidth='xs'>
      <Header
          links={[
            { to: '/register', name: 'Register' },
          ]}
        />
      <form onSubmit={onSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label='Email'
                  name='email'
                  size='small'
                  variant='outlined'
                  defaultValue={loginForm.email}
                  onChange={(evt) =>
                    setLoginForm({ ...loginForm, email: evt.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label='Password'
                  name='password'
                  size='small'
                  type='password'
                  variant='outlined'
                  defaultValue={loginForm.password}
                  onChange={(evt) =>
                    setLoginForm({ ...loginForm, password: evt.target.value })
                  }
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Button
              style={{ backgroundColor: '#1d4589', color: '#F79420' }}
              fullWidth
              type='submit'
              variant='contained'
            >
              Log in
            </Button>
          </Grid>
        </Grid>
      </form>
      {!!response.error && <Error error={response.error} />}
      <Loading loading={response.isLoading} />
    </Container>
  );
}
